import { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Download } from 'lucide-react';
import api from '../services/api.jsx';
import PolicyReviewPanel from './PolicyReviewPanel.jsx';
import { downloadPolicyReviewExcel, normalizePolicyReview } from './policyReview.js';
import '../styles/Admin.css';

const PolicyReviewRun = () => {
  const { runId } = useParams();
  const [run, setRun] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const normalized = useMemo(() => (data == null ? null : normalizePolicyReview(data)), [data]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    api.get(`/admin/zoho/policy-review/runs/${encodeURIComponent(runId)}`)
      .then(res => {
        if (cancelled) return;
        setRun(res.data?.run || null);
        setData(res.data?.data ?? null);
      })
      .catch(err => {
        if (cancelled) return;
        setError(err.response?.status === 403
          ? 'You do not have permission to view policy review results.'
          : err.response?.data?.error || 'Failed to load policy review run.');
      })
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, [runId]);

  return (
    <div className="container">
      <div className="admin-jobdiva-card">
        <div className="admin-jobdiva-table-toolbar">
          <h2>SDP Policy Review — {run?.startedAt ? new Date(run.startedAt).toLocaleDateString() : `Run ${runId}`}</h2>
          {normalized && (
            <button type="button" onClick={() => downloadPolicyReviewExcel(normalized, run?.startedAt || new Date())}>
              <Download size={16} aria-hidden="true" /> Download to Excel
            </button>
          )}
        </div>
        <Link to="/admin">Back to Admin</Link>
        {loading && <div>Loading policy review...</div>}
        {error && <div role="alert">{error}</div>}
        {run && (
          <div className="admin-jobdiva-status-grid" style={{ margin: '12px 0' }}>
            <div><strong>Status:</strong> {run.status}</div>
            <div><strong>Trigger:</strong> {run.triggerSource}{run.triggeredBy ? ` (${run.triggeredBy})` : ''}</div>
            <div><strong>Started:</strong> {run.startedAt ? new Date(run.startedAt).toLocaleString() : '—'}</div>
            <div><strong>Completed:</strong> {run.completedAt ? new Date(run.completedAt).toLocaleString() : '—'}</div>
            {run.errorMessage && <div><strong>Error:</strong> {run.errorMessage}{run.correlationId ? ` (Correlation ID: ${run.correlationId})` : ''}</div>}
          </div>
        )}
        {!loading && !error && !normalized && <div>No full results were stored for this run.</div>}
        {normalized && <PolicyReviewPanel data={normalized} />}
      </div>
    </div>
  );
};

export default PolicyReviewRun;
